import { createRoute, redirect } from '@tanstack/react-router'
import { t } from 'i18next'

import { ErrorBoundary } from '@shared/components/ErrorHandling'
import { DashboardSkeleton } from '@shared/layouts'
import { StaticRouteParameter, DynamicRouteParameterWPrefix } from 'config/routing'
import { AVIO } from 'domains/ContentProcessing/AvcInstances/Instance'
import { Dashboard } from 'domains/ContentProcessing/AvcInstances/Instance/Dashboard'
import { Tasks as AvcInstanceTasks } from 'domains/ContentProcessing/AvcInstances/Instance/Tasks'
import { Structure } from 'pages/NWPlatform/AvcSystem/Instances/Instance/Structure'
import { avcInstancesRoute } from 'pages/NWPlatform/AvcSystem/Instances/Routing'

export const avcInstanceRoute = createRoute({
  getParentRoute: () => avcInstancesRoute,
  path: DynamicRouteParameterWPrefix.AVC_INSTANCE_ID,
  beforeLoad: ({ location, params }) => {
    if (location.pathname.endsWith(params.avcInstanceId) || location.pathname.endsWith(`${params.avcInstanceId}/`)) {
      throw redirect({ replace: true, from: avcInstanceRoute.fullPath, to: dashboardRoute.to })
    }
  },
  loader: () => ({
    crumb: t('entity:content.avcInstance', { count: 1 }),
  }),
})

export const avcInstanceLayoutRoute = createRoute({
  getParentRoute: () => avcInstanceRoute,
  id: 'avcInstanceLayoutRoute',
  component: Structure,
})

export const dashboardLayoutRoute = createRoute({
  getParentRoute: () => avcInstanceLayoutRoute,
  id: 'dashboardLayout',
  component: DashboardSkeleton,
})

export const dashboardRoute = createRoute({
  getParentRoute: () => dashboardLayoutRoute,
  path: StaticRouteParameter.DASHBOARD,
  component: Dashboard,
  errorComponent: ErrorBoundary,
})

type AvcInstanceTasksSearch = {
  query?: string
}

export const avcInstanceTasksRoute = createRoute({
  getParentRoute: () => avcInstanceLayoutRoute,
  path: StaticRouteParameter.AVC_INSTANCE_TASKS,
  component: AvcInstanceTasks,
  validateSearch: (search: Record<string, unknown>): AvcInstanceTasksSearch => ({
    ...(!!search.query && typeof search.query === 'string' && { query: search.query }),
  }),
})

export const avioRoute = createRoute({
  getParentRoute: () => avcInstanceLayoutRoute,
  path: StaticRouteParameter.AVIO,
  component: AVIO,
})
